export default __webpack_public_path__ + "static/media/success_vector.e2285f83.svg";